import { render, staticRenderFns } from "./InformesView.vue?vue&type=template&id=b18e01b4"
import script from "./InformesView.vue?vue&type=script&lang=js"
export * from "./InformesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports